import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import AddIndiaElectricMobility from "./AddIndiaElectricMobility";
import HelperService from "../../utility/HelperService";

const IndiaElectricMobility = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    WebService.getAPI({
      action: `council/getContent?type=INDIA_ELECTRIC`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        // toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  return (
    <>
      <AddIndiaElectricMobility
        show={showAddModal}
        handleClose={() => {
          setShowAddModal(false);
          getData();
        }}
        data={data}
      />
      <div className="events-main">
        <Card className="event-card p-4">
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 100 }}
            >
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <div className="page-title">
                  India Electric Mobility Council
                </div>
                {pagePermission.canEdit && (
                  <CustomButton
                    isLoading={false}
                    label={data ? "Edit" : "Add"}
                    onClick={() => {
                      setShowAddModal(true);
                    }}
                    style={{ width: 100 }}
                  />)}
              </div>
              {data === null ? (
                <div>No data found</div>
              ) : (
                <>
                  {data?.logo && (
                    <div className="mb-2 mt-2">
                      <img
                        src={data.logo}
                        alt="Event"
                        style={{
                          objectFit: "contain",

                          height: "auto",
                        }}
                      />
                    </div>
                  )}

                  <div className="mb-3">
                  <strong>Title</strong>
                  {data?.title && <div>{data.title}</div>}
                  </div>

                  <strong>Description</strong>
                  {data?.description && (
                    <div className="ql-snow">
                      <div
                        className="mt-2 px-0 ql-editor"
                        dangerouslySetInnerHTML={{ __html: HelperService.getPreviewableHTML(data.description) }}
                      />
                    </div>
                  )}
                  {data?.buttons && data.buttons.length > 0 && (
                    <>
                      <h5 className="mt-4 mb-3">Buttons</h5>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 16,
                        }}
                      >
                        {data.buttons.map((btn: any, index: number) => (
                          <a
                            key={index}
                            href={btn.url}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              textDecoration: "none",
                            }}
                          >
                            <button
                              style={{
                                minWidth: 220,
                                padding: "12px 20px",
                                borderRadius: 30,
                                fontSize: 14,
                                fontWeight: 600,
                                cursor: "pointer",
                                border: btn.highlight
                                  ? "none"
                                  : "1.5px solid #0d6efd",

                                background: btn.highlight
                                  ? "#0d6efd" // 🔵 highlighted (second button)
                                  : "#ffffff", // ⚪ normal

                                color: btn.highlight ? "#ffffff" : "#0d6efd",

                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 8,

                                boxShadow: btn.highlight
                                  ? "0 6px 18px rgba(13,110,253,0.35)"
                                  : "none",

                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(-2px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                              }}
                            >
                              {btn.title}
                              <span style={{ fontSize: 16 }}>→</span>
                            </button>
                          </a>
                        ))}
                      </div>
                    </>
                  )}


                  {data?.trust_areas && data.trust_areas.length > 0 && (
                    <>
                      <h5 className="mt-4 mb-3">Focus Areas</h5>

                      <div className="d-flex flex-wrap gap-3">
                        {data.trust_areas.map(
                          (trustarea: any, index: number) => (
                            <div
                              key={trustarea._id || index}
                              className="border rounded-3 p-3 d-flex flex-column align-items-center"
                              style={{ width: 220 }}
                            >
                              {/* LOGO */}
                              {trustarea.logo && (
                                <img
                                  src={trustarea.logo}
                                  alt={
                                    trustarea.title || `Key Area ${index + 1}`
                                  }
                                  style={{
                                    width: 160,
                                    height: 120,
                                    objectFit: "contain",
                                  }}
                                  className="mb-2"
                                />
                              )}

                              {/* TITLE */}
                              {trustarea.title && (
                                <div className="text-center fw-semibold">
                                  {trustarea.title}
                                </div>
                              )}
                            </div>
                          )
                        )}
                      </div>
                    </>
                  )}

                  {data?.members && data.members.length > 0 && (
                    <>
                      <h5 className="mt-4 mb-3">Our EV Community Members</h5>

                      <div className="d-flex flex-wrap gap-3">
                        {data.members.map((member: any, index: number) => (
                          <div
                            key={member._id || index}
                            className="border rounded-3 p-3 d-flex flex-column align-items-center"
                            style={{ width: 220 }}
                          >
                            {/* LOGO */}
                            {member.logo && (
                              <img
                                src={member.logo}
                                alt={member.title || `Key Area ${index + 1}`}
                                style={{
                                  width: 160,
                                  height: 120,
                                  objectFit: "contain",
                                }}
                                className="mb-2"
                              />
                            )}

                            {/* TITLE */}
                            {member.name && (
                              <div className="text-center fw-semibold">
                                {member.name}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </>
                  )}


                </>
              )}
            </>
          )}
        </Card>
      </div>
    </>
  );
};

export default IndiaElectricMobility;
